import React from 'react';

const BlogPost = ({ title, date, content }) => {
  const blogPostStyles = {
    backgroundColor: 'white',
    borderRadius: '8px',
    padding: '16px',
    marginBottom: '16px',
    boxShadow: "0px 0px 35px 0px #e9e9e9",
  };

  const titleStyles = {
    fontSize: '24px',
    marginBottom: '8px',
  };

  const dateStyles = {
    fontSize: '14px',
    color: '#888',
    marginBottom: '8px',
  };

  const contentStyles = {
    fontSize: '16px',
    lineHeight: '1.5',
  };

  return (
    <div style={blogPostStyles}>
      <h2 style={titleStyles}>{title}</h2>
      <p style={dateStyles}>Published on {date}</p>
      <div style={contentStyles}>{content}</div>
    </div>
  );
};

export default BlogPost;
